module.exports = __webpack_public_path__ + "img/home4.d7206268.jpg";